import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { PageChangedEvent } from "ngx-bootstrap/pagination";
import { Observable } from "rxjs";

@Component({
    selector: 'app-grid-pagination',
    templateUrl: './grid-pagination.component.html',
    styleUrls: ['./grid-pagination.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GridPaginationComponent {
    private _totalItemsText: string = 'Total:';
    private _itemsPerPage: number;
    private _totalItems: Observable<number>;
    private _page: number;

    get totalItemsText(): string {
        return this._totalItemsText;
    }

    get itemsPerPage(): number {
        return this._itemsPerPage;
    }

    get totalItems(): Observable<number> {
        return this._totalItems;
    }

    get page(): number {
        return this._page;
    }

    @Input() set itemsPerPage(value: number) {
        this._itemsPerPage = value;
    }

    @Input() set totalItems(value: Observable<number>) {
        this._totalItems = value;
    }

    @Input() set totalItemsText(value: string) {
        this._totalItemsText = value;
    }    
    
    @Input() set page(value: number) {
        const _previous = this._page;
        this._page = value;
        if (_previous === this._page || typeof _previous === 'undefined') {
            return;
        }        
        this.pageChange.emit(this._page);
        this.pageChanged.emit({
            page: this._page,
            itemsPerPage: this.itemsPerPage
        });
    }

    @Output() pageChange = new EventEmitter<number>();

    @Output() pageChanged = new EventEmitter<PageChangedEvent>();

    constructor() {
    }
}


